export const JARGON = {
  ADV: "Advanced",
  AIC: "Association of Investment Companies",
  COMPANY_TYPE: {
    TRADE: "Trading",
    INVEST: "Investment"
  },
  COMPANY_TIMELINE: {
    FOUNDED: "Founded",
    CEASED: "Ceased",
  },
  ADVISER: "Adviser",
  ADVISERS: "Advisers",
  ADVISER_CLIENT: "LSE Client",
  AMBIGUOUS_COMPANY: "This adviser does not appear to be a UK incorporated company or organisation",
  APPT: "Role", // "Directorship",
  APPTS: "Roles", // "Directorships",
  SHORT_APPTS: "Roles", // "Dirs",
  MORE_INFO: "click for more information",
  NOT_APPLICABLE: "not applicable",
  REFRESH: "Refresh",
  DELETE: "Delete",
  EDIT: "Edit",
  ENDING: "Outgoing",
  EPIC: "Ticker",
  EPICS: "Tickers",
  GENERATE: "Generate",
  CREATE: "Create",
  USED: "Report Pack",
  UNUSED: "Hidden",
  OFFICER: "Officer",
  OFFICERS: "Officers",
  DIRECTOR: "Director",
  DIRECTORS: "Directors",
  CONNECTION: "Connection",
  CONNECTIONS: "Connections",
  PSC: "PSC",
  COMPANY: "Company",
  COMPANIES: "Companies",
  GOVERNANCE: "Governance",
  COMMITTEES: "Committees",
  COMMITTEE_ROLES: "Committee roles",
  DATES: "Dates",
  BOARD: "Board",
  OVERVIEW: "Overview",
  PERSON: "Person",
  PEOPLE: "People",
  FAVOURITE: "favourite",
  FAVOURITES: "favourites",
  LSE: "LSE",
  LSE_GROUP: "LSE Group",
  LSE_GROUP_TT: "London Stock Exchange index (or group) that includes company shares",
  DASHBOARD: "Dashboard",
  INCORPORATED: "Incorporated",
  ICB_INDUSTRY: "ICB Industry",
  MISSING_DATA: "MISSING DATA",
  NEWS: "News",
  NEWS_RELEASE: "news release",
  RECENT_NEWS: "Recent news",
  NOT_DISCLOSED: "?",
  LAST_STRING: "ZZZZZ",
  OTHER: "Other",
  CH_UNKNOWN_START_DATE: "before 1989",
  FUTURE_DATE: "2050-01-01",
  // Avoid 1700-01-01 because we are only looking for year and time zones complicationscould make this 1699
  NOW: "current",
  THE350CLUB: "350club",
  ROLE: "Board Role",
  ROLES: "Board roles",
  EXEC: "Executive Role?",
  INDEPENDENT: "Independent Role?",
  NO_ROLE: "None",
  CHEAT_SHEET: "Snapshot",
  UPSELL_PHRASE: "Numerable is available for enterprise use, with advanced search, filter and analysis",
  SEX: "Gender",
  NATIONALITY: "Nationality",
  RESIDENCE: "Resident of",
  UNKNOWN: "n/a",
  CODIRECTOR: "Co-director",
  CODIRECTORS: "Co-directors",
  CONNECTED_CO: "Connected Company",
  CONNECTED_COS: "Connected Companies",
  LSE_COMPANY_TYPE: "LSE Type",
  TOTAL_REMUNERATION: "Total Pay",

  TIMELINE: "Timeline",
  TABLE: "Table",
  DIAGRAM: "Diagram",
  SUBSCRIBED_USERS_ONLY: " (subscribed users only)",
  NOT_INCLUDED_IN_TRIAL: " (not included in your trial)",
  TRIAL_LSE_INDEX_LOCKED: "Only FTSE 100 companies are included in your trial",
  EXTERNAL_LINK_TO: "external link to ",
  NO_COMMITTEE_DATA: "No committee data available yet",
  UNSAVED_CHANGES: "You have unsaved changes, are you sure you want to leave?",

  // NB: Camel-case prop reflects Camel-case value
  TENSE: {
    Status: "Status",
    Current: "Current",
    Notice: "Current (Outgoing)",
    Past: "Past",
    Future: "Incoming",
  }
}

// Create lowercase props eg current: "current"
for (const [key, value] of Object.entries(JARGON.TENSE))
  JARGON.TENSE[key.toLowerCase()] = value.toLowerCase()

JARGON.PDF = {
  age: "Age",
  appointed: "First Appointed to Board",
  coDir: JARGON.CODIRECTOR,
  company: JARGON.COMPANY,
  employees: "Employees",
  epic: `${JARGON.LSE} ${JARGON.EPIC}`,
  director: JARGON.DIRECTOR,
  directors: JARGON.DIRECTORS,
  index: `${JARGON.LSE} Index`,
  mrktCap: "Market capitalisation",
  overlap: "Overlap",
  remuneration: `${JARGON.TOTAL_REMUNERATION} (£)`,
  resigned: "Resigned from Board",
  resigning: "Resigned from Board",
  role: JARGON.APPT,
  sex: JARGON.SEX,
  tenure: "Board Tenure",
  via: `Via ${JARGON.PERSON}`,
}